import React from 'react';
import { 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  FormHelperText,
  Box,
  Typography
} from '@mui/material';
import { countries, preferredCountries } from '../../data/countries';

const CountrySelector = ({ 
  label, 
  value, 
  onChange, 
  error, 
  helperText,
  required = false,
  disabled = false,
  ...props 
}) => {
  const selectedCountry = countries.find(country => country.code === value);

  return (
    <FormControl fullWidth error={!!error} disabled={disabled} {...props}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value || '+591'}
        onChange={(e) => onChange(e.target.value)}
        label={label}
        renderValue={(selected) => {
          const country = countries.find(c => c.code === selected);
          return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography component="span" sx={{ fontSize: '1.2em' }}>
                {country?.flag}
              </Typography>
              <Typography component="span">
                {country?.code}
              </Typography>
            </Box>
          );
        }}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 300,
            },
          },
        }}
      >
        {countries.map((country) => (
          <MenuItem 
            key={`${country.code}-${country.iso}`} 
            value={country.code}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              '&:hover': {
                backgroundColor: 'action.hover',
              }
            }}
          >
            <Typography component="span" sx={{ fontSize: '1.2em' }}>
              {country.flag}
            </Typography>
            <Typography component="span" sx={{ flex: 1 }}>
              {country.name} ({country.code})
            </Typography>
          </MenuItem>
        ))}
      </Select>
      {(error || helperText) && (
        <FormHelperText>
          {error || helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default CountrySelector;